
import React, {useState} from 'react';

const ContainerChart = props => {
    const [isOpen, setIsOpen] = useState(false);
    function toggle() {
        setIsOpen((isOpen) => !isOpen);
    }


    return (
        <div className={'chart-container ' + (props.Classe ?? '')}>
            <div className="dr-container">
                <div className="chart-title">
                    <h2 className="mb-0">{ props.title }</h2>
                </div>
            </div>
            <div className="dr-container-chart">
                { props.children }
                <ul className={"list-unstyled list-inline text-center legend " + (props.legendCSSClass ?? 'list-inline')}>
                    {props.legend.map((item, i) => {
                            return (
                                <li className={item.customCSSClass ?? "list-inline-item"} key={i}>
                                    <div>
                                        {item.color && <span className="point" style={{backgroundColor: item.color}} />}
                                        <span className="legend-note">{item.title}</span>
                                    </div>
                                </li>
                            )
                    })}
                </ul>
                <p className="source text-center note-white">{ (props.source) ? props.source : null }</p>
                <div className="map-info" onClick={toggle}> إخلاء المسؤولية <img src={require('../images/info-maps.svg').default}/></div>
                <p className="note text-center note-white" style={ isOpen ? { display:'block'} : {}}>{ (props.note) ? props.note : renderSource() }</p>
            </div>
        </div>
    ) 
}

const renderSource = () => {
    const l = document.getElementsByTagName('html')[0].getAttribute('lang');

    switch(l) {
        case 'en':
            return 'SOURCE: FAO, 2023c.';
        case 'es':
            return 'Fuente: FAO, 2023c.';
        case 'zh':
            return '资料来源：粮农组织，2023。';
        case 'ru':
            return 'ИСТОЧНИК: ФАO, 2023.';
        case 'ar':
            return 'المصدر: منظمة الأغذية والزراعة، 2023.';
        default:
            return 'SOURCE: FAO, 2023c.';
    }
}

export default ContainerChart;